import * as yup from 'yup'

const schema = yup.object().shape({
  categoryId: yup.string().required('Selecione alguma opção'),
  subCategoryId: yup.string().required(),
  title: yup.string().required().max(200),
  description: yup.string().richTextRequired(),
})

export default schema
